import { publicConfig } from "./config";

const { PHP_SITE_DOMAIN } = publicConfig;

const routes = {
	purchase: {
		base: "/purchase/",
		configSubscription: "/purchase/configure-subscription",
		billing: "/purchase/billing",
		placeOrder: "/purchase/payment",
		invoice: "/purchase/invoice",
		confirmRenewal: "/purchase/confirm-renewal",
	},
	auth: {
		login: "/auth/login",
		signUp: "/auth/signup",
		logout: "/auth/sign-out",
		exchange: "/auth/exchange",
		forgotPassword: "/auth/forgot-password",
		forgotPasswordSuccess: "/auth/forgot-password/success",
		resetPassword: "/auth/reset-password",
		resetPasswordSuccess: "/auth/reset-password/success",
		resetPasswordFail: "/auth/reset-password/fail",
	},
	myAccount: "/account",
	myAccountPreferences: "/account/preferences",
	subscription: {
		dashboard: "/account/subscription",
		activations: "/account/subscription/activations",
		renew: "/account/subscription/renew",
		settings: "/account/subscription/settings",
		billing: {
			index: "/account/subscription/billing",
			changePaymentMethod: "/account/subscription/billing/changepayment",
			changePlan: "/account/subscription/billing/changeplan",
			activations: "/account/subscription/billing/activations",
		},
		billingInfoUpdate: "/account/subscription/billinginfo-update",
		invoice: "/account/subscription/invoice",
		purchaseActivations: "/account/subscription/purchase-activations",
		cancelSurvey: "/account/subscription/cancel-survey",
		cancelConfirm: "/account/subscription/cancel-confirm",
		upgradeTrialPlan: "/account/subscription/upgrade-trial-plan",
		upgradeTrialSuccess: "/account/subscription/upgrade-trial-success",
		upgradeTrialPayment: "/account/subscription/upgrade-trial-payment",
	},
	invoice: {
		pay: "/invoice/pay",
		success: "/invoice/pay-success",
		invalid: "/invoice/invalid",
	},
	freeTrial: "/free-trial",
	confirmEmail: "/free-trial/confirm-email",
	completeProfile: "/free-trial/complete-profile",
	exchangeTrial: "/api/free-trial/exchange",
	courseLicenses: "/free-course-license",
	igem: "/igem",
	errors: {
		403: "/403",
		404: "/404",
		default: "/error",
	},
	external: {
		index: `//${PHP_SITE_DOMAIN}/`,
		howToBuy: `//${PHP_SITE_DOMAIN}/pricing/`,
		support: "//support.geneious.com/",
		termsOfService: `//${PHP_SITE_DOMAIN}/legal/`,
		privacyPolicy: `//${PHP_SITE_DOMAIN}/privacy-policy/`,
		contactUs: `//${PHP_SITE_DOMAIN}/contact-us/`,
		prime: `//${PHP_SITE_DOMAIN}/prime/`,
		biopharma: `//${PHP_SITE_DOMAIN}/biopharma/`,
		solutions: `//${PHP_SITE_DOMAIN}/solutions/`,
		resources: `//${PHP_SITE_DOMAIN}/resources/`,
		features: `//${PHP_SITE_DOMAIN}/features/`,
		tutorials: `//${PHP_SITE_DOMAIN}/tutorials/`,
		plugins: `//${PHP_SITE_DOMAIN}/plugins/`,
		whatsNew: `//${PHP_SITE_DOMAIN}/whats-new/`,
		crispr: `//${PHP_SITE_DOMAIN}/crispr/`,
		freeTrial: `//${PHP_SITE_DOMAIN}/free-trial/`,
		download: `//${PHP_SITE_DOMAIN}/download/`,
		quote: `//${PHP_SITE_DOMAIN}/quote/`,
		about: `//${PHP_SITE_DOMAIN}/about/`,
		leadership: `//${PHP_SITE_DOMAIN}/about/leadership/`,
		news: `//${PHP_SITE_DOMAIN}/about/news/`,
		careers: `//${PHP_SITE_DOMAIN}/about/careers/`,
		licenseAgreement: "//assets.geneious.com/legal/eula.html",
		help: "https://help.geneious.com/",
		manual: "https://manual.geneious.com/en/latest/",
		coronavirus: `//${PHP_SITE_DOMAIN}/resources/coronavirus-resources/`,
		freeTrialExternal: "https://manage-dev.geneious.com/free-trial",
		courseLicenses: `//${PHP_SITE_DOMAIN}/free-course-license`,
		igem: `//${PHP_SITE_DOMAIN}/igem`,
		dotmatics: "https://www.dotmatics.com/",
		portfolio: "https://www.dotmatics.com/portfolio",
		careersExternal: "https://www.dotmatics.com/about-careers",
		customers: `//${PHP_SITE_DOMAIN}/customers`,
		citations: `//${PHP_SITE_DOMAIN}/citations`,
	},
};
export default routes;
